var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41,4H13c-1.6542969,0-3,1.3457031-3,3v3H7c-1.6542969,0-3,1.3457031-3,3v26c0,2.7568359,2.2431641,5,5,5h30 c2.7568359,0,5-2.2431641,5-5V7C44,5.3457031,42.6542969,4,41,4z M42,39c0,1.6542969-1.3457031,3-3,3H9 c-1.6542969,0-3-1.3457031-3-3V13c0-0.5517578,0.4482422-1,1-1h3v26h2V7c0-0.5517578,0.4482422-1,1-1h28 c0.5517578,0,1,0.4482422,1,1V39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,10H19c-1.6542969,0-3,1.3457031-3,3v2c0,1.6542969,1.3457031,3,3,3h16c1.6542969,0,3-1.3457031,3-3v-2 C38,11.3457031,36.6542969,10,35,10z M36,15c0,0.5517578-0.4482422,1-1,1H19c-0.5517578,0-1-0.4482422-1-1v-2 c0-0.5517578,0.4482422-1,1-1h16c0.5517578,0,1,0.4482422,1,1V15z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 22,
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 22,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsMedium);
export default __webpack_public_path__ + "static/media/news--medium.413b42ddfbc0547b9d00383d9776225a.svg";
export { ForwardRef as ReactComponent };